export default __webpack_public_path__ + "static/media/news_detail_bottom.ec4856a6.png";